import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSimpleAlert from "vue-simple-alert";
import SocketIO from "socket.io-client";
import VueSocketIO from "vue-socket.io";
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_URL_API;
// import vueTap from "vue-tap-and-hold";
// Vue.use(vueTap, {
//   holdTime: 2000, // default is 1000
//   tapTime: 200, // default is 200
// });
Vue.config.productionTip = false;
Vue.use(VueSimpleAlert);
// Socket.IO client should send credentials for cross-origin cookies (CORS)
const options = {
  withCredentials: true,
  transports: ["polling"],
};

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: SocketIO(process.env.VUE_APP_URL_SERVER, options),

    // options: { path: "/my-app/" } //Optional options
  })
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
